/** The error type controls which error modal gets used */
export enum ErrorType {
  Generic = "Generic",
  CreateBlockedByOrgPolicy = "CreateBlockedByOrgPolicy",
  CreateBlockedByCreditLimit = "CreateBlockedByCreditLimit",
}
